<style>
	.header {
		height: 44px!important;
		background-color: #F6F6F6;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		border-bottom:solid 1px #EAEAEA;
	}
	
	.logo {
		width: 26px;
		height: 26px;
		border-radius: 6px;
		overflow: hidden;
	}
	.logo-name {
		margin-left: 10px;
		font-weight: bold;
		font-size: 14px;
		
	}
	.flr {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	
	.avatars {
		width: 30px;
		height: 30px;
		border-radius: 7px;
		margin-right: 10px;
	}
	.nickname {
		font-size: 14px;
	}
	
	.menu-item {
		cursor: pointer;
		height: 44px; 
		line-height: 44px; 
		width: 196px;
		text-align: center; 
		
		background-color: #FFFFFF;
		border-right: solid 3px #FFFFFF;
		
		display: flex;
		flex-direction: row;
		align-items: center;
		position: relative;
	}
	
	.sub-menu-item {
		cursor: pointer;
		height: 44px;
		line-height: 44px; 
		width: 196px;
		text-align: center; 
		
		background-color: #F9F9F9;
		border-right: solid 3px #F9F9F9;
		
		display: flex;
		flex-direction: row;
		align-items: center;
		position: relative;
	}
	.menu-parent-check {
		color: #1677FF;
	}
	.menu-check {
		background-color: #E7F5FF;
		border-right: solid 3px #1677FF;
		color: #1677FF;
	}
	.menu-icon {
		width: 20px;
		margin-left: 20px;
		margin-right: 10px;
	}
	.menu-name {
		font-size: 14px;
	}
	.menu-dir {
		position: absolute;
		right: 10px;
	}
	
	.div-no-scrollbar {
	  overflow: auto; /* 保持可滚动 */
	  scrollbar-width: none; /* 对于 Firefox 隐藏滚动条 */
	}
	 
	.div-no-scrollbar::-webkit-scrollbar {
	  display: none; /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
	}
	
	.app-list {
		width: 100px; height: calc(100vh - 44px); overflow-y: scroll;
		scrollbar-width: none; /* 对于 Firefox 隐藏滚动条 */
		border-right: solid 1px #dcdcdc;
	}
	.chat-list {
		width: 220px; background-color: #EEEEEE;
		height: calc(100vh - 44px); overflow-y: scroll;
		border-right: solid 1px #dcdcdc;
		overflow-x: hidden;
	}
	.chat-list::-webkit-scrollbar {
		width: 6px;
	}
	.chat-list::-webkit-scrollbar-track {
		background-color: #FFFFFF;
	}
	.chat-list::-webkit-scrollbar-thumb {
		background-color: #DCDCDC;
	}
	.chat-list::-webkit-scrollbar-thumb::hover {
		background-color: #CCCCCC;
	}
	.chat-title {
		width: 220px; text-align: center;
		height: 40px;
		line-height: 40px;
		background-color: #3377ff;
		color: white;
		position: sticky;
		top: 0;
		cursor: pointer;
	}
	.chat-one {
		display: flex; flex-direction: row;
		padding: 10px 10px;
		align-items: center;
		border-bottom: solid 1px #dcdcdc;
		background-color: #FAFAFA;
		cursor:pointer;
		position:relative;
	}
	
	.chat-one-active {
		background: #DCDCDC !important;
	}
	.chat-name-box {
		font-size: 12px;
		line-height: 18px;
	}
	.fb {
		font-weight: bold;
	}
	.fgrey {
		color: #999999;
	}
	.chat-avatar {
		width: 30px;
		height: 30px;
		border-radius: 30px;
		overflow: hidden;
		margin-right: 8px;
	}
	.app-box {
		display: flex; flex-direction: column; align-items: center; justify-content: center;
		
		font-size: 12px;
		position: relative;
		padding: 20px 0;
		line-height: 24px;
		cursor:pointer;
	}
	.app-active {
		background-color: #CCCCCC;
	}
	.app-icon {
		width: 40px; height: 40px;
		border-radius: 10px;
		overflow: hidden;
	}
	.dot {
		width: 8px;
		height: 8px;
		background-color: orangered;
		color: white;
		border-radius: 14px;
		line-height: 16px;
		text-align: center;
		padding: 4px;
		position: absolute;
		right: 12px;
		top: 12px;
	}
	
	.chating-title {
		width: 100%;
		background-color: white;
		height: 60px;
		display: flex;
		flex-direction: row;
		align-items: center;
		border-bottom: solid 1px #dcdcdc;
	}
	.chating-avatar {
		width: 36px; height: 36px;
		border-radius: 36px;
		overflow: hidden;
		margin: 0 10px 0 20px;
	}
	.chating-nickname {
		font-size: 16px;
		margin-right: 10px;
	}
	.chating-online {
		font-size: 12px;
		color: red;
	}
	.chat-body {
		width: 100%;
		height: calc(100vh - 44px - 280px);
		background-color: white;
	}
	.chating-action-box {
		background-color: white;
		height: 218px;
		width: 100%;
		display: flex;
		flex-direction: column;
	}
	.mtextarea {
		
	}
	
	.el-textarea__inner {
		box-shadow: 0 0 0 !important;
		background-color: white !important;
		color: black !important;
		border: 0;
		font-size: 16px;
		color: #333333;
	}
	
	.chating-menu {
		width: 100%;
		height: 40px;
		border-top: solid 1px #dcdcdc;
		display: flex;
		flex-direction: row;
		align-items: center;
		color: #999999;
	}
	
	.im-content-box {
		overflow-y:scroll;
		background: #F6F6F6;
	}
	.im-content-box2 {
		padding: 8px;
	}
	.im-avatar {
		width:40px; height:40px;
	}
	.im-status {
		background:#DDDDDD; margin: 6px 0; font-size: 10px; padding: 3px 8px; color: white;
		border-radius: 3px;
	}
	.im-text {
		background-color: white; padding: 10px; border-radius: 5px; 
		max-width: 300px;
		overflow:hidden;
		word-wrap:break-word;
	}
	.im-text img {
		max-width: 200px;
	}
	.im-time {
		color:#999; font-size:12px;
	}
	.flrs {
		display: flex;
		flex-direction: row;
	}
	.flc {
		display: flex;
		flex-direction: column;
	}
	.mdot {
		width: 20px;
		height: 20px;
		background:red;
		color:white;
		font-size:12px;
		text-align:center;
		line-height: 20px;
		border-radius: 20px;
		position: absolute;
		top:18px;
		right: 10px;
	}
</style>

<template>
	<div id="app">
		<el-container>
			<el-header class="header">
				<div class="flr">
					<img class="logo" src="../assets/logo.jpg" />
					<div class="logo-name">健安集团 · 客服中心</div>
					<div v-if="isConnected" style="margin-left: 50px; color: green;">已连接</div>
					<div v-if="!isConnected" style="margin-left: 50px; color: red;">连接中</div>
				</div>
				<el-popover placement="bottom" width="90" style="min-width: 90px!important;" trigger="click">
					<div style="text-align: center; cursor: pointer;" @click="logout"><i class="el-icon-s-fold" style="margin-right:5px;"></i>退出登录</div>
					<div class="flr" style="cursor: pointer; margin-right: 20px;" slot="reference">
						<img class="avatars" :src="avatar" />
						<div class="nickname">{{nickname}}</div>
					</div>
				</el-popover>
			</el-header>
			<el-container style="background-color: #F5F5F5; height: calc(100vh - 44px); ">
				<div class="app-list">
					<div @click="changeApp('SPIRIT')" :class="['app-box', current_app == 'SPIRIT' ? 'app-active' : '']">
						<img src="../assets/mnjl.png" class="app-icon" />
						<div>模拟精灵</div>
						<div v-if="app_list[0].unread!=0" class="dot"></div>
					</div>
					<div @click="changeApp('TOUTIAO')" :class="['app-box', current_app == 'TOUTIAO' ? 'app-active' : '']">
						<img src="../assets/newstime.png" class="app-icon" />
						<div>时事头条</div>
						<div v-if="app_list[1].unread!=0" class="dot"></div>
					</div>
					<div @click="changeApp('hxyj')" :class="['app-box', current_app == 'hxyj' ? 'app-active' : '']">
						<img src="../assets/hxyj.png" class="app-icon" />
						<div>鸿喜云集</div>
						<div v-if="app_list[2].unread!=0" class="dot"></div>
					</div>
					<div @click="changeApp('hyll')" :class="['app-box', current_app == 'hyll' ? 'app-active' : '']">
						<img src="../assets/hxyj.png" class="app-icon" />
						<div>好运连连</div>
						<div v-if="app_list[3].unread!=0" class="dot"></div>
					</div>
					
				</div>
				<div class="chat-list">
					<div class="chat-title" @click="groupViewFunc">{{current_app_name}} [群发]</div>
					<div @click="changeSession(item)" class="chat-one" :class="['chat-one',  sender_imid == item.sender_imid ? 'chat-one-active' : '']" v-for="(item,index) in friend_list">
						<img :src="item.avatar" class="chat-avatar"/>
						<div class="chat-name-box">
							<div class="fb">账号 {{item.nickname}}</div>
							<div class="fgrey">{{formatTimestamp(item.last_time)}}</div>
						</div>
						<div class="mdot" v-if="item.unread">{{item.unread}}</div>
					</div>
				</div>
				<div style="flex-grow: 1; height: calc(100vh - 44px); background-color: #EFEFEF;" v-if="current_user.im_id != ''">
					<div class="chating-title">
						<img :src="current_user.avatar" class="chating-avatar" />
						<div class="chating-nickname">{{current_user.nickname}}</div>
						<div class="chating-online">[在线]</div>
					</div><!-- 
					<div class="chat-body">聊天内容</div> -->
					
					<div class="chat-body im-content-box" ref="messageContainer" >
						<div v-for="(item,index) in message_list" :key="index">
							<div class="im-content-box2" v-if="username !== item.sender_nickname">
								<div class="flrs" style="margin-left: 10px;">
									<img :src="item.sender_avatar" class="im-avatar" />
									<div class="flc" style="margin-left: 8px;">
										<div style="line-height: 30px;">
											{{item.sender_nickname}}<span class="im-time" style="margin-left:10px;">{{formatTimestamp(item.timestamp)}}</span>
										</div>
										<div class="im-text" style="align-self: flex-start;">
											<div v-if="item.msg_type==='text'">{{item.content}}</div>
											<div v-if="item.msg_type==='image'"><img @dblclick="previewImage(item.content)" :src="item.content" /></div>
										</div>
										<div class="im-status" style="align-self: flex-start;">
											<span v-if="item.status===0">发送中</span>
											<span v-if="item.status===1">已发送</span>
											<span v-if="item.status===2">已读</span>
										</div>
									</div>
								</div>
							</div>
							<div class="im-content-box2" v-if="username === item.sender_nickname">
								<div class="flrs" style="margin-right: 10px; justify-content: right;">
									<div class="flc" style="margin-right: 8px;">
										<div style="line-height: 30px; text-align: right;">
											<span class="im-time" style="margin-right:10px;">{{formatTimestamp(item.timestamp)}}</span>{{item.sender_nickname}}
										</div>
										<div class="im-text" style="align-self: flex-end;">
											<div v-if="item.msg_type==='text'">{{item.content}}</div>
											<div v-if="item.msg_type==='image'"><img @dblclick="previewImage(item.content)" :src="item.content" /></div>
										</div>
										<div class="im-status" style="align-self: flex-end;">
											<span v-if="item.status===0">发送中</span>
											<span v-if="item.status===1">已发送</span>
											<span v-if="item.status===2">已读</span>
										</div>
									</div>
									<img :src="item.sender_avatar" class="im-avatar" />
								</div>
							</div>
						</div>
					</div>
					<div class="chating-action-box">
						<div class="chating-menu">
							<el-tooltip class="box-item" effect="dark" content="发送图片" placement="top-start">
								<el-upload :show-file-list="false" action="https://ws.fkinfo88.com/Api/Publics/uploadImage" :on-success="UploadSuccess" :before-upload="beforeAvatarUpload" accept="image/*">
									<img src="../assets/image.png" style="margin-left: 20px; width: 28px;" />
								</el-upload>
							</el-tooltip>
							<el-tooltip class="box-item" effect="dark" content="清除聊天记录" placement="top-start">
								<img src="../assets/clear.png" @click="clearMessageRecord" style="margin-left: 20px; width: 22px; cursor: pointer;" />
							</el-tooltip>
						</div>
						
						<el-input ref="myInput" class="mtextarea" v-model="be_message" type="textarea" rows='4' resize="none"></el-input>
						
						<div style="display: flex; flex-direction: row; justify-content: right; margin-top: 10px;">
							<el-button type="primary" style="width: 120px; margin-right: 10px;" @click="sendMessageFunc">发送</el-button>
						</div>
					</div>
				</div>
				<!-- <router-view style=" overflow-y: auto;  overflow-x: hidden; width:0;"></router-view> -->
			</el-container>
		</el-container>
		
		<el-dialog :title="groupTitle" v-if="groupView" :visible.sync="groupView" width="1000" :before-close="handleClose">
			<Group @message="getMessage" :appInfo="appInfo"></Group>
		</el-dialog>
		
		<audio ref="audioPlayer">
			<source src="../assets/msg.mp3" type="audio/mp3" />
		</audio>
	</div>
</template>

<script>
	
import Group from './group.vue';

import { watch } from 'vue';
import { mapState } from 'vuex';

  export default {
    name: 'MainFrame',
	components:{
		Group
	},
	computed:{
		...mapState({
			avatar:state=>state.avatar,
			nickname:state=>state.nickname
		}),
		keydownHandler(){
			return (event)=>{
				if(event.key == 'Enter'){
					this.sendMessageFunc();
				}	
			};
		}
	},
    data(){
      return {
		  appInfo:{},
		  groupView:false,
		  groupTitle:'',
		  ImInfo:{},
		  current_app:'SPIRIT',
		  current_app_name:'模拟精灵',
		  sender_imid:'',
		  app_list:[
			  {
				  app:'SPIRIT',
				  name:'模拟精灵',
				  icon:'/assets/mnjl.png',
				  unread:0,
				  api_url:'https://api.rhd777.com/Api/Publics/getGroupList'
			  },{
				  app:'TOUTIAO',
				  name:'时事头条',
				  icon:'../assets/newstime.png',
				  unread:0,
				  api_url:'https://api.hhsj798.xyz/Api/Publics/getGroupList'
			  },{
				  app:'hxyj',
				  name:'鸿喜云集',
				  icon:'../assets/hxyj.png',
				  unread:0,
				  api_url:'https://hxyj-api.fkinfo88.com/app/Channel/userList'
			  },{
				  app:'hyll',
				  name:'好运连连',
				  icon:'../assets/hxyj.png',
				  unread:0,
				  api_url:'https://hyll-api-api.fkinfo88.com/app/Channel/userList'
			  }
		  ],
		  friend_list:[],
		  // 消息记录
		  current_user:{
			  im_id:'',
			  user_key:'',
			  nickname:'',
			  username:'',
			  avatar:'',
			  online:false,
		  },
		  
		  timer:null,
		  receiver:'spirit_user_38',
		  be_message:'',
		  ws: null,          // WebSocket 实例
		  isConnected: false, // WebSocket 是否连接成功
		  messages: [],      // 存储接收到的消息
		  reconnectAttempts: 0, // 记录重连次数
	 
		  username:'官方客服',
		  be_message:'',
		  top_open:1,
		  sub_open:0,
		  openIndex:'',
		  message_list:[]
      }
    },
	created() {
		this.$store.commit('recoverState');
		this.$router.beforeEach((to, from, next) => {
			this.openIndex = to.path;
			next();
		});
	},
	mounted(){
		// 刷新页面，重置已点击菜单
		this.openIndex = this.$route.path;
		if(this.openIndex == "/")
		{
			this.$router.push("/Dashboard");
		}
		
		this.scrollToBottom();
		this.refreshFriendList();
		
		document.addEventListener('keydown', this.keydownHandler);
		
		this.getImInfo();
	},
	methods:{
		videoRun(){
			const audio = this.$refs.audioPlayer;
			audio.currentTime = 0;
			audio.play();
		},
		getMessage(e){
			const loading = this.$loading({
					lock: true,
					text: '群发中..',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			e.list.forEach((v,k)=>{
				this.sendMessage(JSON.stringify({code:9001, type:e.type, receiver:v, message:e.message}));
			})
			loading.close();
		},
		handleClose(){
			this.groupView = false;
		},
		groupViewFunc(){
			let _app = {};
			this.app_list.forEach((v,k)=>{
				if(v.app == this.current_app){
					_app = v;
				}
			})
			this.appInfo = _app;
			this.groupTitle = _app.name + '[群发]';
			this.groupView = true;
		},
		getImInfo(){
			let _this = this;
			const loading = this.$loading({
					lock: true,
					text: 'IM系统登录中',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			_this.$api.post("/User/getImInfo", {}).then(res=>{
				loading.close();
				if(res.code == 200)
				{
					_this.ImInfo = res.data;
					_this.createWebSocket();
					_this.timer = setInterval(this.getWSping, 15000);
				}else{
					return _this.$message({
						 message: res.msg,
						 type: 'warning',
					});
				}
				
			}).catch(err=>{
				loading.close();
			});
		},
		changeApp(_app){
			if(this.current_app == _app){
				return;
			}
			this.current_app = _app;
			this.current_user = {
				im_id:'',
				user_key:'',
				nickname:'',
				username:'',
				avatar:'',
				online:false,
			};
			let _app_name = '';
			switch(_app){
				case 'SPIRIT': _app_name = '模拟精灵'; break;
				case 'TOUTIAO': _app_name = '时事头条'; break;
				case 'hxyj': _app_name = '鸿喜云集'; break;
				case 'hyll': _app_name = '好运连连'; break;
			}
			this.current_app_name = _app_name;
			this.refreshFriendList();
			
			this.app_list.forEach((v,k)=>{
				if(v.app == this.current_app){
					this.app_list[k].unread = 0;
				}
			});
		},
		changeSession(_item){
			console.log("changeSession", _item);
			// 清除角标
			this.friend_list.forEach((v,k)=>{
				if(v.im_id == _item.im_id){
					this.friend_list[k].unread = 0;
				}
			});
			let _friend_list_key = this.current_app + '_FRIEND_LIST';
			localStorage.setItem(_friend_list_key, JSON.stringify(this.friend_list));
			
			//this.sender_imid = _item.sender_imid;
			this.current_user = _item;
			// 恢复聊天内容
			let _message_list = localStorage.getItem(_item.im_id);
			_message_list = JSON.parse(_message_list);
			this.message_list = _message_list;
			this.$nextTick(() => {
				this.scrollToBottom();
			});
			this.be_message = '';
			//this.$refs.myInput.focus();
		},
		sendMessageFunc(){
		   if(this.be_message.trim() === '') return;
			
			console.log(this.current_user)
			this.sendMessage(JSON.stringify({code:9001, type:'text', receiver:this.current_user.im_id, message:this.be_message.trim()}));
			this.be_message = '';
		},
		messageAction(_data){
			let _app = _data.app;
			let _msg_key = '';
			// 处理聊天记录
			if(_data.app == 'admin'){
				_msg_key = _data.receiver_imid;
			}else{
				_msg_key = _data.sender_imid;
			}
			let _message_list = localStorage.getItem(_msg_key);
			if(!_message_list){
				_message_list = [];
				_message_list.push(_data);
			}else{
				_message_list = JSON.parse(_message_list) ?? [];
				_message_list.push(_data);
			}
			localStorage.setItem(_msg_key, JSON.stringify(_message_list));
			if(this.current_user.im_id == _msg_key){
				this.message_list = _message_list;
				this.$nextTick(() => {
					this.scrollToBottom();
				});
			}
			// 处理好友列表
			let _friend_list_key = _app + '_FRIEND_LIST';
			let _friend_list = localStorage.getItem(_friend_list_key);
			if(_friend_list != null){
				_friend_list = JSON.parse(_friend_list) ?? [];
			}else{
				_friend_list = [];
			}
			if(_data.app != 'admin'){
				let _friend = {
					im_id:_data.sender_imid,
					avatar:_data.sender_avatar,
					nickname:_data.sender_nickname,
					username:_data.sender_nickname,
					last_time:_data.timestamp,
					unread:1
				};
				let _flg = false;
				_friend_list.forEach((v,k)=>{
					if(v.im_id == _data.sender_imid){
						_flg = true;
						if(this.current_user.im_id != v.sender_imid){
							// 如果当前聊天用户是 发消息来的用户
							_friend_list[k].last_time = _friend.last_time;
							_friend_list[k].unread = v.unread + 1;
						}else{
							_friend_list[k].last_time = _friend.last_time;
							_friend_list[k].unread = 0;
						}
					}
				});
				if(_flg == false){
					_friend_list.push(_friend);
				}
				_friend_list = _friend_list.sort((a,b)=>b.last_time - a.last_time);
				localStorage.setItem(_friend_list_key, JSON.stringify(_friend_list));
				if(this.current_app == _data.app){
					this.friend_list = _friend_list;
				}
			}
			if(this.current_app != _app){
				//console.log(this.current_app, _app);
				this.app_list.forEach((v,k)=>{
					if(v.app == _app){
						this.app_list[k].unread = 1;
					}
				});
			}
		},
		refreshFriendList(){
			// 保存好友列表记录
			let _friend_list_key = this.current_app + '_FRIEND_LIST';
			let _friend_list = localStorage.getItem(_friend_list_key);
			if(_friend_list){
				this.friend_list = JSON.parse(_friend_list);
				console.log(this.friend_list);
			}else{
				this.friend_list = [];
			}
		},
		createWebSocket() {
			let _this = this;
			let ws_url = this.ImInfo.im_url + this.ImInfo.im_token;
			this.ws = new WebSocket(ws_url); // 替换为你的 WebSocket 服务器地址
		
			// 当 WebSocket 连接打开时
			this.ws.onopen = () => {
				this.isConnected = true;
				this.reconnectAttempts = 0; // 连接成功，重连次数归零
				console.log('WebSocket connected!');
			};
		
			// 当 WebSocket 接收到消息时
			this.ws.onmessage = (event) => {
				let _obj = JSON.parse(event.data);
				if(_obj?.code === 7001){
					_this.messageAction(_obj.data);
					_this.videoRun();
				}
			};
		
			// 当 WebSocket 连接关闭时
			this.ws.onclose = () => {
			this.isConnected = false;
			console.log('WebSocket disconnected!');
			this.reconnect(); // 调用重连方法
			};
		
			// 当 WebSocket 出现错误时
			this.ws.onerror = (error) => {
			console.error('WebSocket error:', error);
			this.ws.close(); // 关闭连接后触发 onclose
			};
		},
		scrollToBottom() {
			const container = this.$refs.messageContainer;
			if (container) {
				container.scrollTop = container.scrollHeight; // 滚动到最底部
			}
		},
		// 断线重连
		reconnect() {
		  if (this.reconnectAttempts < 100) { // 限制重连次数
			this.reconnectAttempts++;
			const delay = Math.min(1000 * this.reconnectAttempts, 5000); // 延迟重连，最多 5 秒
			console.log(`Reconnecting in ${delay / 1000} seconds...`);
			
			setTimeout(() => {
			  this.createWebSocket(); // 重建 WebSocket 连接
			}, delay);
		  } else {
			console.log('Max reconnect attempts reached.');
		  }
		},
		getWSping(){
			this.sendMessage(JSON.stringify({'code':9999, 'msg':'ping'}));
		},
		// 发送消息
		sendMessage(message) {
		  if (this.ws && this.isConnected) {
			this.ws.send(message); // 发送消息到 WebSocket 服务器
		  } else {
			console.log('WebSocket is not connected.');
		  }
		},
		clearMessageRecord(){
			this.message_list = [];
			localStorage.setItem(this.current_user.im_id, null);
		},
		async uploadOss(ossConfig, file){
			console.log(ossConfig, file);
			const response = await fetch(file);
			const blob = await response.blob();
			console.log(blob);
		},
		UploadSuccess(res, file, fileList){
			if(res.code == 200)
			{
				this.sendMessage(JSON.stringify({code:9001, type:'image', receiver:this.current_user.im_id, message:res.data.url}));
			}else{
				return this.$message({ message: res.msg, type: 'warning' });
			}
		},
		beforeAvatarUpload(file){
			return;
			let that = this;
			that.$api.post("/Publics/getOss", {}).then(res=>{
				if(res.code == 200){
					that.uploadOss(res.data, file);
				}
			}).catch(err=>{
			});
			return;
			let _this = this;
			let reader = new FileReader();
			let ret =  reader.readAsDataURL(file);
			reader.onload = () => {
				let _load = this.$loading({lock: true, text: '发送中', background: 'rgba(0, 0, 0, 0.7)'});
				_this.sendMessage(JSON.stringify({code:9001, type:'image', receiver:this.current_user.im_id, message:reader.result}));
				_load.close();
			};
			return false;
		},
		
		clickTopMenu(menu){
			if(this.top_open == menu.id) {
				this.top_open = 0;
				return;
			}
			this.top_open = menu.id;
			if(this.$route.path == menu.url){
				this.$router.go(0);
			}else if(menu.url != ""){
				this.$router.push(menu.url);
			}
		},
		clickSubMenu(sub, parent){
			this.sub_open = sub.id;
			if(this.$route.path == sub.url){
				this.$router.go(0);
			}else{
				this.$router.push(sub.url);
			}
		},
		changePassApi(){
			let that = this;	
			if(this.old_password.length.length < 6 || this.new_password.length <6 || this.new_password1.length < 6)
			{
				return that.$message({
					 message: '请输入完整的密码',
					 type: 'warning',
				});
			}
			if(this.new_password != this.new_password1)
			{
				return that.$message({
					 message: '新前后密码不一致',
					 type: 'warning',
				});
			}
			const loading = this.$loading({
					lock: true,
					text: '修改密码中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			
			that.$api.post("/Admin/changePassword", {old_password:that.old_password, new_password:that.new_password}).then(res=>{
				loading.close()
				if(res.code == 1)
				{
					return that.$message({
						 message: res.msg,
						 type: 'success',
					});
				}else{
					return that.$message({
						 message: res.msg,
						 type: 'warning',
					});
				}
			}).catch(err=>{
				loading.close()
			});
		},
		passwordClose(){
			this.old_password = "";
			this.new_password = "";
			this.new_password1= "";
		},
		refresh(){

		},
		logout(){
			this.$store.commit("Logout");
			const loading = this.$loading({
				lock: true, 
				text: '退出登录中',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			setTimeout(() => {
				loading.close();
				this.$router.push("/Login");
			}, 800);
					
					
		},
		tagClick(e){
			this.$router.push(e);
		},
		tagClose(e){
			let new_tags = [];
			let index = -1;
			this.tags.forEach((k,v)=>{
				if(k.path != e)
				{
					new_tags.push(k);
				}else{
					index = v;
				}
			});
			if( index != -1) index -=1;
			if( index < 0 ) index = 0;
			this.tags = new_tags;
			this.$router.push(this.tags.at(index).path);
			this.saveTags();
		},
		onSelect(path)
		{
			let item = null;
			this.menu_list.forEach((k,v)=>{
				k.sub_menu.forEach( (kk, vv)=>{
					if(path == kk.url)
					{
						item = kk;
					}
				})
			})
			let flag = false;
			this.tags.forEach((k, v)=>{
				if(k.path == item.url)
				{
					flag = true;
				}
			})
			if(!flag)
			{
				this.tags.push({name:item.title, path:item.url, close:true});
			}
			this.saveTags();
		},
		saveTags(){
			localStorage.setItem("TagsLine", JSON.stringify(this.tags));
		},
		formatTimestamp(timestamp) {
			// 将时间戳转换为毫秒
			const date = new Date(timestamp * 1000);
			// 获取日期和时间的各个部分
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');
			// 格式化为字符串
			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		},
	}
  }
</script>